import React from 'react'

import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'
import 'highlight.js/styles/stackoverflow-light.css'

hljs.registerLanguage('json', json)

export const CodeFormatter = ({ code }) => {
    const highlightedCode = hljs.highlight(JSON.stringify(code, null, 2), {
        language: 'json',
    }).value

    return (
        <pre className="mb-0">
            <code
                dangerouslySetInnerHTML={{
                    __html: highlightedCode,
                }}
            ></code>
        </pre>
    )
}
